<template>
  <div>
    <vs-row vs-w="12">
      <vs-col
        class="mb-3"
        vs-type="flex"
        vs-align="center"
        vs-lg="6"
        vs-sm="6"
        vs-xs="12"
      >
        <vs-input
          color="#333f50"
          style="width: 310px"
          label="Network Name"
          class="inputx ml-2"
          type="string"
          placeholder="Name"
          v-model="name"
        />
      </vs-col>
    </vs-row>

    <vs-row class="ml-3 mt-3" vs-w="12">
      <vs-spacer />
      <vs-button
        type="filled"
        size="large"
        style="border-radius: 20px"
        color="success"
        @click="createnw()"
        >Create Network</vs-button
      >
      <vs-button
        class="ml-2 mr-4"
        type="flat"
        color="dark"
        style="border-radius: 20px"
        @click="cancel()"
      >
        Cancel
      </vs-button>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: "ViewNetwork",
  data: () => ({
    name: null,
    check: true,
  }),
  components: {},
  methods: {
    cancel() {
      location.reload();
    },
    createnw() {
      var username = this.$session.get("username");
      this.$API.get("network/user").then((result) => {
        for (let i = 0; i < result.data.length; i++) {
          if (result.data[i].name === this.name) this.check = false;
        }
        if (this.check && this.name != null) {
          this.$API
            .post("network", {
              name: this.name,
              username: username,
            })
            .then(() => {
              this.$vs.notify({
                title: "Create Network",
                text: "Complete!",
                color: "success",
                position: "top-center",
                icon: "check",
              });
              setTimeout(() => {
                location.reload();
              }, 200);
            });
          this.name = null;
        } else if (this.name == null) {
          this.$vs.notify({
            title: "Create Network",
            text: "Please enter network name",
            color: "danger",
            position: "top-center",
            icon: "cancel",
          });
        } else {
          this.$vs.notify({
            title: "Create Network",
            text: "Duplicate Name",
            color: "danger",
            position: "top-center",
            icon: "cancel",
          });
          this.name = null;
        }
        // eslint-disable-next-line no-console
        // console.log(result)
      });
      this.check = true;
    },
  },
};
</script>
<style scoped>
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
</style>